<!-- 巨量点击用户 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="screen-box">
				<div class="screen-label">ID</div>
				<a-input v-model="r_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">点击日期范围</div>
				<a-range-picker style="width:240px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" 
				:disabledDate="DateControl"
				@calendarChange="calendarChangeA"
				@openChange="openChangeA"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">点击时间范围</div>
				<!-- <a-range-picker style="width:240px;" @change="onChangeDateB" :allowClear="false"
				:locale="locale" allowClear 
				:value="[show_click_start,show_click_end]" /> -->
				<a-range-picker
					style="width:340px;"
					:locale="locale" 
				    :show-time="{ format: 'HH:mm:ss' }"
				    format="YYYY-MM-DD HH:mm:ss"
				    :placeholder="['开始时间', '结束时间']" 
				    @change="onChangeDateB"
				    @ok="onDateC_ok" 
				/>
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">公众号ID</div>
				
				<!-- <a-select
					style="min-width: 200px"
					placeholder="请选择公众号ID"
					:filter-option="filterOption"
					@change="handleChangeB"
					:getPopupContainer="getsPopupContainer" 
					showSearch
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterList.gzh_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select> -->
				
				<moreSelect
				 ref="getGzhSelect"
				:placeholder="'请选择公众号'"
				:select_mode="''"
				@handleChangeSelect="handleChangeB"
				></moreSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">落地页ID</div>
				<a-input v-model="r_link_id_l" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">快应用/短剧渠道</div>
				<a-select
					style="width: 200px"
					placeholder="快应用/短剧渠道"
					:filter-option="filterOption"
					@change="handleChangeQ"
					:getPopupContainer="getsPopupContainer" 
					showSearch
					allowClear
				  >
					<a-select-option v-for="(value,key) in qkVdChannel" :key="key" :value="key" :title="value">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广链接ID</div>
				<a-input v-model="r_link_id_t" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">IP</div>
				<a-input v-model="r_ip" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">IP 所在城市</div>
				<a-input v-model="r_city" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">OAID</div>
				<a-input v-model="r_oaid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">OAID_md5</div>
				<a-input v-model="r_oaid_md5" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">IMEI</div>
				<a-input v-model="r_imei" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<!-- <div class="screen-box">
				<div class="screen-label">ANDROIDID</div>
				<a-input v-model="r_androidid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div> -->
			
			<div class="screen-box">
				<div class="screen-label">巨量账户ID</div>
				<a-input v-model="r_adv_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量1.0计划ID</div>
				<a-input v-model="r_adid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量1.0创意ID</div>
				<a-input v-model="r_creativeid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量2.0 项目ID</div>
				<a-input v-model="r_project_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量2.0 广告ID</div>
				<a-input v-model="r_promotion_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<!-- <div class="screen-box">
				<div class="screen-label">省份</div>
				<a-input v-model="r_province" allowClear placeholder="请输入" style="width: 200px;"  />
			</div> -->

			
			
			<!-- <div class="screen-box">
				<div class="screen-label">MAC</div>
				<a-input v-model="r_mac" allowClear placeholder="请输入" style="width: 200px;"  />
			</div> -->
			
			
			
			<!-- <div class="screen-box">
				<div class="screen-label">是否回传充值</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div> -->
			
			<!-- <div class="screen-box">
				<div class="screen-label">是否有充值</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeE" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div> -->
			
			<div class="screen-box">
				<div class="screen-label">是否匹配注册</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeF" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			<!-- <a-button @click="exportButton" type="primary" icon="download" class="screen-box" >导出</a-button> -->
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="item.id" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index && z_tem.type != 'click_time'" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
					<div v-else-if="z_ndex <= sticky_index && z_tem.type == 'click_time'" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type] | clickDate}}
					</div>
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.type != 'link_id_l' && z_tem.type != 'link_id_t' && z_tem.type != 'ip_city' && z_tem.type != 'callback' && z_tem.type != 'has_register'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- 落地页ID -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'link_id_l'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<template v-if="item.gzh_id">{{item.link_id}}</template>
				</div>
				<!-- 推广链接ID -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'link_id_t'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<template v-if="!item.gzh_id">{{item.link_id}}</template>
				</div>
				<!-- IP地址 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'ip_city'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.province}} {{item.city}} {{item.county}}
				</div>
				<!-- Callback参数 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'callback'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<a-popover placement="top">
						<template slot="content">
						  <p style="width: 320px;word-break: break-all;">{{item.callback}}</p>
						</template>
						<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
							{{item.callback}}
						</div>
					</a-popover>
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'has_register'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.has_register == 1?'是':'否'}}
				</div>
			</template>
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': body_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<!-- <div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 41px;">
			<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': body_width - 60 + 'px',}">
				<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" 
				:showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" hideOnSinglePage/>
			</div>
		</div> -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width - 60"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<!-- 手动回传 -->
	<a-modal :visible="hc_visible" title="确认要回传？" @ok="hcOk" @cancel="hcCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_confirm_loading">
	    <div>ID：{{hc_id}}</div>
	</a-modal>
	
	<!-- 自定义回传 -->
	<!-- <a-modal :visible="hc_Zdy_visible" title="自定义回传" @ok="hcZdyOk" @cancel="hcZdyCancel"
	cancelText="取消" okText="确认" :confirmLoading="hc_Zdy_loading">
		<div class="form-cell-box">
			<div class="class-title">落地页用户类型</div>
			<a-select
				:value="h_report_id_type"
			    style="width: 290px"
			    placeholder="请选择"
			    @change="handleChangeH"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option value="0">自建落地页</a-select-option>
				<a-select-option value="1">基木鱼</a-select-option>
				<a-select-option value="3">巨量点击检测</a-select-option>
			</a-select>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">落地页用户ID</div>
	    	<a-input v-model="h_report_id" placeholder="前往对应落地页用户类型页面复制ID" style="width: 290px;"  />
	    </div>
	</a-modal> -->
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, LdJlList, LdLinkUserReport, orderGzhCustomReport, getQkVdChannel } from '@/request/api'
import moreSelect from '@/components/selectCompont/moreSelect.vue'
export default {
	name: 'orderGzh_',
	components: {
		moreSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			r_start_click_time: '', // 点击日期
			r_end_click_time: '', // 点击日期
			show_click_start: '', // 点击日期开始
			show_click_end: '', // 点击日期结束
			
			PlatformData: {},
			is_admin: false, // 为true表示 超级管理员
			is_super: false, // 为true表示放管理
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"点击日期", width:100, type:"date_key", },
				{title:"点击时间", width:160, type:"click_time", },
				
				{title:"公众号", width:120, type:"gzh_name", },
				{title:"快应用/短剧渠道", width:120, type:"channel_id", },
				{title:"落地页ID", width:140, type:"link_id_l", },
				{title:"推广链接ID", width:140, type:"link_id_t", },
				
				{title:"IP", width:160, type:"ip", },
				{title:"IP所在地", width:150, type:"ip_city", },
				
				// {title:"UA", width:200, type:"ua", },
				// {title:"Mac", width:150, type:"mac", },
				{title:"OAID", width:170, type:"oaid", },
				{title:"OAID_md5", width:150, type:"oaid_md5", },
				{title:"IMEI", width:150, type:"imei", },
				{title:"AndroidID", width:150, type:"androidid", },
				
				{title:"巨量账户ID", width:150, type:"adv_id", },
				{title:"巨量1.0计划ID", width:160, type:"adid", },
				{title:"巨量1.0创意ID", width:160, type:"creativeid", },
				{title:"巨量2.0 项目ID", width:150, type:"project_id", },
				{title:"巨量2.0 广告ID", width:150, type:"promotion_id", },
				{title:"巨量回传callback", width:150, type:"callback", },
				
				
				// {title:"账户名称", width:100, type:"adv_name", },
				// {title:"计划名称", width:100, type:"plan_name", },
				// {title:"Promotion_id", width:130, type:"promotion_id", },
				// {title:"Project_id", width:130, type:"project_id", },
				
				{title:"是否匹配注册", width:100, type:"has_register", },
				
				// {title:"是否充值", width:100, type:"has_pay", },
				// {title:"充值回传次数", width:120, type:"report_count", },
				// {title:"注册回传次数", width:120, type:"reg_callback_times", },
				// {title:"注册回传时间", width:150, type:"reg_report_time", },
				// {title:"Callback参数", width:200, type:"callback", },
				
				{title:"创建时间", width:160, type:"created_at", },
				{title:"更新时间", width:160, type:"updated_at", },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			sticky_index: 2,
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			
			r_id: null, // ID
			r_link_id_l: null, // 落地页ID
			r_link_id_t: null, // 推广链接ID
			r_oaid_md5: null, 
			
			r_gzh_id: null, // 公众号id
			r_adid: null, // 计划ID
			r_creativeid: null, // 创意ID
			r_ip: null, // 用户IP
			
			// r_province: "", // 省份
			r_city: "", // 城市
			// r_mac: "", // MAC
			
			r_imei: null, // IMEI
			r_oaid: null, // OAID
			r_androidid: null, // ANDROIDID
			r_link_id: null, // 推广链接ID
			
			r_channel_id: undefined, // 快应用/短剧渠道
			r_adv_id: null, // 巨量账户ID
			r_project_id: null, // 巨量2.0 项目ID
			r_promotion_id: null, // 巨量2.0 广告ID
			
			r_has_register: undefined, // 是否有注册。0为否。1为是
			// r_has_pay: "", // 是否有充值 0为否。1为是
			// r_is_report: "", // 是否回传充值 0为否。1为是
			
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
			
			qkVdChannel: {}, // 获取快应用和短剧渠道
			
			calendarDate: [],
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		
		// 获取7天前日期
		// that.startTime = this.$getBeforeDay(7)
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay()
		
		getQkVdChannel().then(res=>{
			console.log("获取快应用和短剧渠道",res);
			that.qkVdChannel = res.data.data.list
		})
		
		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			that.filterList = res.data.data.filter
			
			// 公众号
			that.$refs.getGzhSelect.getSelectData(that.filterList.gzh_id.list || [])
			
			that.is_admin = res.data.data.is_admin
			
			// 搜索
			that.searchButton()
		})
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		calendarChangeA(e,d){
			console.log("待选日期发生变化的回调",e,d);
			this.calendarDate = e
		},
		openChangeA(status){
			console.log("弹出日历和关闭日历的回调",status);
			if(!status){ // 关闭
				this.calendarDate = [] 
			}
		},
		// 日期范围控制，根据权限来
		DateControl(current){
			// console.log("current",current);
			// console.log("this.calendarDate",this.calendarDate);
			const span = 3; // 时间跨度
			let dates = this.calendarDate
			
			// 定义了一个state-dates,用来存储当前选择的日期,然后进行跨度选择
			//当dates数组的length为0或者为2时,说明还未选择或者已经选择完了,则根据最大查询范围比较
			if(!dates || dates.length === 0 || dates.length === 2) {
				return 
			}
			// 当dates邀组的length为1时,说明当前日期已经选择了起始日期,正准备选择就止日期呢,则黑示时同跨度限制
			//在选择日期之后最大查询范围(选择的日期,前后按时间跨度可选C
			let afterSelectMin = moment(dates[0]).subtract(span -1, 'day');
			let afterSelectMax = moment(dates[0]).add(span, 'day');
			//除了在选择日期之后按时间跨度限制,还要保持之前的范围限制不不变,求并集
			return current && (current < afterSelectMin || current >= afterSelectMax);
			
			// return current && current > moment().endOf('day') || current < moment().subtract(90, 'day');
		},
		// 点击日期
		onChangeDateB(date, dateString){
			console.log('点击日期',date, dateString);
			// if(dateString[0]){
			// 	this.show_click_start = this.moment(dateString[0], this.dateFormat) || '' // 点击日期开始
			// 	this.show_click_end = this.moment(dateString[1], this.dateFormat) || '' // 点击日期结束
			// }
			// else {
			// 	this.show_click_start =  '' // 点击日期开始
			// 	this.show_click_end =  '' // 点击日期结束
			// }
			
			
			this.r_start_click_time = dateString[0]
			this.r_end_click_time = dateString[1]
		},
		onDateC_ok(value){
			// console.log('onOk: ', value);
		},
		handleChangeB(e){ // 公众号
			console.log(e);
			this.r_gzh_id = e
		},
		handleChangeD(e){ // 是否回传
			console.log(e);
			this.r_is_report = e
		},
		handleChangeE(e){ // 是否已充值 0为否。1为是
			console.log(e);
			this.r_has_pay = e
		},
		handleChangeF(e){ // 是否有注册
			this.r_has_register = e
		},
		handleChangeH(e){ // 落地页用户类型
			this.h_report_id_type = e
		},
		handleChangeQ(e){ // 快应用/短剧渠道
			// console.log("快应用/短剧渠道",e);
			this.r_channel_id = e
		},
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				
				id: that.r_id,
				start_date_key: that.startTime.replace(/-/g, ''),
				end_date_key: that.endTime.replace(/-/g, ''),
				start_click_time: that.r_start_click_time, // 点击日期开始
				end_click_time: that.r_end_click_time, // 点击日期结束
				
				adid: that.r_adid, // 计划ID
				gzh_id: that.r_gzh_id, // 公众号id
				
				creativeid: that.r_creativeid, // 创意ID
				ip: that.r_ip, // 用户IP
				// mac: that.r_mac, // MAC
				imei: that.r_imei, // IMEI
				oaid: that.r_oaid, // OAID
				oaid_md5: that.r_oaid_md5,
				// androidid: that.r_androidid, // ANDROIDID
				has_register: that.r_has_register, // 是否有注册
				// is_report: that.r_is_report, // 是否回传充值
				
				// province: that.r_province, // 省份
				city: that.r_city, // 城市
				// has_pay: that.r_has_pay, // 已充值 0为否。1为是
				
				channel_id: that.r_channel_id, // 快应用/短剧渠道
				adv_id: that.r_adv_id, // 巨量账户ID
				project_id: that.r_project_id, // 巨量2.0 项目ID
				promotion_id: that.r_promotion_id // 巨量2.0 广告ID
			}
			if(that.r_link_id_l && !that.r_link_id_t){ // 只有落地页ID
				r_data.link_id = that.r_link_id_l
			}
			else if(!that.r_link_id_l && that.r_link_id_t){ // 只有推广链接ID
				r_data.link_id = that.r_link_id_t
			}
			else {
				r_data.link_id = that.r_link_id_l // 两个都填了就随便取一个
			}
			LdJlList(r_data).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					// that.is_super = res.data.data.is_super // 是否是投放管理员
					
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		// 回传操作
		HcTdTable(e,type){
			if(type == 0){ // 手动回传头条
				this.hc_id = e.id
				this.hc_visible = true
			}
			else if(type == 1){ // 自定义回传
				this.hc_id = e.id
				this.hc_Zdy_visible = true
				
			}
		},
		// 手动回传弹窗确认按钮
		hcOk(){
			let that = this
			that.hc_confirm_loading = true
			LdLinkUserReport({
				id: that.hc_id
			}).then(res=>{
				console.log("回传",res);
				that.hc_confirm_loading = false
				
				if(res.data.code == 0){
					that.hcCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
			})
			.catch(err=>{
				that.hc_confirm_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcCancel(){
			if(this.hc_confirm_loading){
				return
			}
			this.hc_visible = false
		},
		// 自定义回传
		hcZdyOk(){
			let that = this
			if(!that.h_report_id_type){
				that.$message.warning('落地页用户类型不能为空');
				return
			}
			else if(!that.h_report_id){
				that.$message.warning('落地页用户ID不能为空');
				return
			}
			
			that.hc_Zdy_loading = true
			orderGzhCustomReport({
				order_id: that.hc_id,
				report_id: that.h_report_id,
				report_id_type: that.h_report_id_type,
			}).then(res=>{
				console.log("自定义回传",res);
				that.hc_Zdy_loading = false
				
				if(res.data.code == 0){
					that.hcZdyCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
				
			})
			.catch(err=>{
				that.hc_Zdy_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcZdyCancel(){
			if(this.hc_Zdy_loading){
				return
			}
			this.h_report_id = ""
			this.h_report_id_type = undefined
			this.hc_Zdy_visible = false
		},
		
		
	},
	filters: {
		clickDate(value){
			let ttt = value
			// console.log(value);
			//时间戳转化成时间格式
			function timeFormat(value) {
			    //value是整数，否则要parseInt转换,不会出现少个0的情况
			    //如果value是10位数的需要 value* 1000
			    var time = new Date(value* 1000);
				// console.log('time',time);
			    var year = time.getFullYear();
				// console.log('time',time);
			    var month = time.getMonth() + 1;
			    var date = time.getDate();
			    var hours = time.getHours();
			    var minutes = time.getMinutes();
			    var seconds = time.getSeconds();
			    return year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
			}
			function add0(m) {
			    return m < 10 ? '0' + m : m
			};
			// console.log(timeFormat(value));
			return timeFormat(value)
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

/* 使用flex来使表格粘性布局内容占满高度 */
.table-td {
	align-items: initial;
}
.table-td-cell-sticky {
	display: flex;
	align-items: center;
}
.table-td-cell {
	display: flex;
	align-items: center;
	font-size: 13px;
}
</style>